export interface UserWithKeys {
  userMetaData: UserMetaData;
  encFeKey: string;
  encPrivateKey: string;
  publicKey: CryptoKey;
}

export interface UserMetaData {
  id: string;
  email: string;
  username: string;
  fullname: string;
}



export interface UserData extends UserMetaData {
  // feKey?: CryptoKey;
  // exportedFeKey: string
}

export enum PrimaryStorage {
  IndexedDB = 'IDB',
  FileSystem = 'FS',
}

export enum BackupFrequency {
  Daily = 'daily',
  Weekly = 'weekly',
  Monthly = 'monthly',
}

export interface AppOptions {
  isMasterTab: boolean;
  // dirPermission: boolean;
  // directoryHandler: FileSystemDirectoryHandle;
}

export interface AppConfigs {
  localBackups: boolean;
  primaryStorage: PrimaryStorage;
  backupFrequency: BackupFrequency;
}

export type AppData = Partial<AppOptions> & AppConfigs;
